import { useQuery } from "@tanstack/react-query";
import { getWorkflow, getWorkflowCatalog } from "../api/workflows";

// Recipes change only with a deploy, so the page does not poll.
const STALE_MS = 5 * 60_000;

export const useWorkflowCatalog = () =>
  useQuery({
    queryKey: ["workflows"],
    queryFn: getWorkflowCatalog,
    staleTime: STALE_MS,
  });

export const useWorkflow = (name: string | null) =>
  useQuery({
    queryKey: ["workflow", name],
    queryFn: () => getWorkflow(name!),
    enabled: !!name,
    staleTime: STALE_MS,
  });
